export default "__VITE_ASSET__CJqC2UV3__"